import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const items = [['J.M.', 'Dance Fitness Instructor — Miami, USA', 'Preparing my classes used to take hours every week. Now I choose the structure and teach. My students notice the difference.'], ['L.R.', 'Certified Fitness Instructor — London, UK', 'The Choreography Library alone is worth the investment. Everything is organized by level and ready to use immediately.'], ['C.T.', 'Fitness Studio Owner — Toronto, Canada', 'This system gave me a framework I can trust to adapt every class without improvising.']];
export function TestimonialsStrip() {
  return <section className="border-y border-line bg-soft py-10" data-id="element-223">
      <div className="mx-auto grid max-w-7xl gap-5 px-4 md:grid-cols-3" data-id="element-224">
        {items.map(([name, role, quote], index) => <motion.figure key={name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="rounded-2xl border border-navy/15 bg-white p-6" data-id="element-225">
            <div className="mb-4 flex gap-1 text-orange" data-id="element-226">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={15} fill="currentColor" data-id="element-227" />)}
            </div>
            <blockquote className="text-sm italic leading-relaxed text-slate-600" data-id="element-228">
              “{quote}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3" data-id="element-229">
              <span className="flex size-9 items-center justify-center rounded-full bg-navy text-xs font-bold text-white" data-id="element-230">
                {name}
              </span>
              <span className="text-xs text-navy" data-id="element-231">{role}</span>
            </figcaption>
          </motion.figure>)}
      </div>
    </section>;
}